module.exports = __webpack_public_path__ + "static/logo-6b4db5592758578b5b8c4cc3e5668632.png";